<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{'monitoring.filters.title.fullLabel' | translate}}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-monitoring-filters-select-date class="item"
            [date]="filters.startDate" (change)="onStartDateChange($event)"
            title="{{'monitoring.filters.startDate.shortLabel' | translate}}"
        ></app-monitoring-filters-select-date>
        <app-monitoring-filters-select-multi class="item"
            [items]="visibleRegions" (selectionChange)="onSelectionChange($event)"
            title="{{'monitoring.filters.region.shortLabel' | translate}}"
            allLabel="{{'monitoring.filters.allF.shortLabel' | translate}}"
        ></app-monitoring-filters-select-multi>
        <app-monitoring-filters-select-multi class="item"
            [items]="visibleProvinces" (selectionChange)="onSelectionChange($event)"
            title="{{'monitoring.filters.province.shortLabel' | translate}}"
            allLabel="{{'monitoring.filters.allF.shortLabel' | translate}}"
        ></app-monitoring-filters-select-multi>
        <app-monitoring-filters-select-multi class="item"
            [items]="visibleMunicipalities" (selectionChange)="onSelectionChange($event)"
            title="{{'monitoring.filters.municipality.shortLabel' | translate}}"
            allLabel="{{'monitoring.filters.allF.shortLabel' | translate}}"
        ></app-monitoring-filters-select-multi>
        <br>
        <app-monitoring-filters-select-date class="item"
            [date]="filters.endDate" (change)="onEndDateChange($event)"
            title="{{'monitoring.filters.endDate.shortLabel' | translate}}"
        ></app-monitoring-filters-select-date>
        <app-monitoring-filters-select-multi class="item"
            [items]="visibleRoles" (selectionChange)="onSelectionChange($event)"
            title="{{'monitoring.filters.role.shortLabel' | translate}}"
            allLabel="{{'monitoring.filters.allM.shortLabel' | translate}}"
        ></app-monitoring-filters-select-multi>
        <app-monitoring-filters-select-multi class="item"
            [items]="visibleLicenceTypes" (selectionChange)="onSelectionChange($event)"
            title="{{'monitoring.filters.licenceType.shortLabel' | translate}}"
            allLabel="{{'monitoring.filters.allM.shortLabel' | translate}}"
        ></app-monitoring-filters-select-multi>
        <app-monitoring-filters-select-multi class="item"
            [items]="visibleBankers" (selectionChange)="onSelectionChange($event)"
            title="{{'monitoring.filters.banker.shortLabel' | translate}}"
            allLabel="{{'monitoring.filters.allM.shortLabel' | translate}}"
        ></app-monitoring-filters-select-multi>
        <button *ngIf="!isLoading; else loader" class="button"
            mat-raised-button [disabled]="isEmpty" color="accent" (click)="onSubmit()"
        >{{'monitoring.filters.submit.shortLabel' | translate}}</button>
        <ng-template #loader>
            <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
        </ng-template>
    </mat-card-content>
</mat-card>
